import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { COMMON_ACTION_TYPE } from 'constants/index';


export const useLocationChange = () => {
  const dispatch = useDispatch();
  let location = useLocation();
  useEffect(() => {
    dispatch({
      type: COMMON_ACTION_TYPE.LOCATION_CHANGE,
      payload: {
        location
      }
    });
  }, [location]);
};

